// /src/Pages/CompanyPage.js
import React from "react";

function CompanyPage() {
  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold">Company Page</h1>
      <p>All company products and details will be listed here.</p>
    </div>
  );
}

export default CompanyPage; // ✅ must be default export